import { ErrorLogComponent } from '@cian/error-log-component';
import { IVisitedOffersProviderProps, VisitedOffersProvider } from '@cian/frontend-visited-offers-widget';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitRoot } from '@cian/ui-kit/root/UiKitRoot';

import { FC, StrictMode } from 'react';

import { ApplicationLayout } from 'shared/components/ApplicationLayout';
import { ServerSideStateProvider } from 'shared/components/ServerSideStateProvider';
import { ApplicationContextProvider } from 'shared/context/ApplicationContext';
import { ClientSideStateContextProvider } from 'shared/context/ServerSideStoreContext';
import { NotificationCenterProvider } from 'shared/utils/NotificationCenter';

import { ActionsCentersLoadable } from './internal/components/ActionsCenters/ActionsCentersLoadable';
import type { ApplicationProps } from './types';

export const Application: FC<ApplicationProps> = props => {
  const { context, serverSideState, clientSideState } = props;

  const {
    logger,
    custom: { initialDeviceType },
    microfrontendsRegistry,
    config,
  } = context;

  const { settings, enabled } = config.get<IVisitedOffersProviderProps>('audience.visitedOffers') || {};

  return (
    <StrictMode>
      <ErrorLogComponent logger={logger}>
        <NotificationCenterProvider />
        <ApplicationContextProvider value={context}>
          <MicrofrontendProvider registry={microfrontendsRegistry}>
            <ClientSideStateContextProvider clientSideState={clientSideState}>
              <ServerSideStateProvider serverSideState={serverSideState}>
                <UiKitRoot useStaticDeviceType deviceType={initialDeviceType}>
                  <VisitedOffersProvider enabled={enabled} settings={settings}>
                    <ApplicationLayout />
                    <ActionsCentersLoadable />
                  </VisitedOffersProvider>
                </UiKitRoot>
              </ServerSideStateProvider>
            </ClientSideStateContextProvider>
          </MicrofrontendProvider>
        </ApplicationContextProvider>
      </ErrorLogComponent>
    </StrictMode>
  );
};
